/**
 * Идентификаторы сторонней аналитики (KAN-1198). Публичны по своей природе —
 * видны в HTML любого сайта со счётчиком, поэтому здесь, а не в секретах.
 * 0 / пустая строка — счётчик выключен.
 */

/** Яндекс.Метрика, счётчик «GoodLuck — gltournament.ru». */
export const YANDEX_METRIKA_ID: number = 112785651;

/**
 * Google Tag Manager (контейнер GTM-PSJKJG72). ВЫКЛЮЧЕН 18.09.2026 решением
 * владельца: GA4 — трансграничная передача ПД в США (уведомление РКН), а цель —
 * обойтись без неё. Включение = вписать ID обратно + вернуть Google в тексты
 * /cookies и /privacy + CSP уже готов.
 */
export const GTM_ID: string = "";
